import _t from 'i18n!nls/front-page';

const getCertificationPrepSpotlightCollectionsData = () => {
  return {
    headline: _t('Prepare for an industry certification exam'),
    description: '',
    ctaText: _t('Explore courses'),
    ctaTarget: '/explore/certification-preparation-courses',
    collectionSets: [
      {
        id: 'certification-prep-spotlight',
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: 'R5xCYezqQzuQ4EomA7oT1A',
      },
    ],
    linearGradientBackground: {
      angle: '90deg',
      colors: [
        'var(--cds-color-emphasis-secondary-background-strong)',
        'var(--cds-color-emphasis-primary-background-default)',
      ],
      stops: [0.03, 99.95],
    },
  };
};

export default getCertificationPrepSpotlightCollectionsData;
